export default __webpack_public_path__ + "static/media/Najd Feki Resume.8b342286.pdf";